// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1fgke{background:#f5f9ff;width:284px}html[dir=ltr] ._1fgke{border-bottom-left-radius:0;border-top-left-radius:0}html[dir=rtl] ._1fgke{border-bottom-right-radius:0;border-top-right-radius:0}._1fgke .DateInput_input{background-color:#f5f9ff;color:#30a8ff;font-weight:700}._1fgke .DateRangePickerInput_arrow{color:#30a8ff;font-weight:700}", ""]);
// Exports
exports.locals = {
	"resultsRange": "_1fgke"
};
module.exports = exports;
